import React, { Component } from 'react';
import './../../assets/css/App.css';
import CustomChart from './../../component/chart'
import Service from './service';

class ChartView extends Component {
    state = {
        emptyTableMessage: 'No data can be found',
        renderChart : false
    }

    componentDidMount () {
        Service.event.onFetchReceivedPackagesByCountry.add((chartData) => {
            this.setState({
                histogramChartCategoriesList: chartData.categoryList,
                histogramChartSeriesDataList: chartData.seriesDataList,
                renderChart : true
            });
        });

        Service.fetchReceivedPackageStatsByCountry(30);
    }

    componentWillUnmount() {

    }

    render() {

        const options = {
            title: {
                text: 'Received Packages by Country for the last 30 days (top 20)'
            },
            xAxis: {
                categories: this.state.histogramChartCategoriesList
            },
            yAxis: {
                title: {
                    text: 'Number of Received Packages by country'
                }
            },
            plotOptions: {
                series: {
                    borderWidth: 0,
                    dataLabels: {
                        enabled: true,
                        format: '{point.y}',
                    }
                }
            },
            series: [{
                name: 'Received Packages last 30 days',
                type: 'column',
                colorByPoint: true,
                data: this.state.histogramChartSeriesDataList
            }]
        };

        return (
            <div>
                { this.state.renderChart ? <CustomChart options={options}/> : '' }
            </div>
        );
    }
}

export default ChartView;